/**
 * LERA Device Engine — Debug instrumentation.
 * Enable via config.debugMode, ?lera_debug=1, or Theme Editor diagnostics.
 */
(function (global) {
  'use strict';

  var LERA = (global.LERA = global.LERA || {});

  function hasUrlDebugFlag() {
    try {
      return Boolean(global.location && /[?&]lera_debug=1(?:&|$)/.test(global.location.search));
    } catch (error) {
      return false;
    }
  }

  function formatError(error) {
    if (!error) return 'Unknown error';

    if (typeof error === 'string') return error;

    var parts = [];
    if (error.name) parts.push(error.name);
    if (error.message) parts.push(error.message);
    if (error.stack) parts.push(error.stack);

    if (!parts.length) {
      try {
        return JSON.stringify(error);
      } catch (jsonError) {
        return String(error);
      }
    }

    return parts.join(' — ');
  }

  var debugApi = {
    enabled: false,

    configure: function (config) {
      this.enabled = Boolean((config && config.debugMode) || hasUrlDebugFlag());
      if (this.enabled) {
        console.info('[LERA:Debug] Debug mode ACTIVE', {
          debugMode: config && config.debugMode,
          urlFlag: hasUrlDebugFlag(),
          optionName: config && config.optionName,
        });
      }
      return this.enabled;
    },

    isEnabled: function () {
      return this.enabled || hasUrlDebugFlag();
    },

    log: function (scope, step, details) {
      if (!this.isEnabled()) return;
      if (details !== undefined) {
        console.log('[LERA:' + scope + '] ' + step, details);
      } else {
        console.log('[LERA:' + scope + '] ' + step);
      }
    },

    warn: function (scope, step, details) {
      if (!this.isEnabled()) return;
      if (details !== undefined) {
        console.warn('[LERA:' + scope + '] ' + step, details);
      } else {
        console.warn('[LERA:' + scope + '] ' + step);
      }
    },

    error: function (scope, step, error, details) {
      if (!this.isEnabled()) return;
      console.error('[LERA:' + scope + '] ' + step, {
        error: formatError(error),
        details: details || null,
      });
    },
  };

  LERA._debug = debugApi;
})(typeof window !== 'undefined' ? window : this);
